import React from 'react';
import './styles.css';

const Loading = () => <div id='loading'></div>;

export default Loading;